import React from "react";
import { Stack } from "@mui/material";
import { useGetUserListQuery } from "@quales/data-access/graphql";
import { useTranslations } from "next-intl";
import { CustomTextField, CustomAutoComplete } from "../ui/input";

interface UsersAutoCompleteProps {
  onValueChanged: any;
  edit?: boolean;
  InputPropsValue?: any;
  width?: number;
  label?: string;
}

export const UsersAutoComplete = function (props: UsersAutoCompleteProps) {
  const { onValueChanged, edit, InputPropsValue, width, label } = props;
  const t = useTranslations();
  const { loading, data } = useGetUserListQuery({
    fetchPolicy: "network-only",
  });

  const [value, setValue] = React.useState(null);
  const [options, setOptions] = React.useState<any>([]);

  React.useEffect(() => {
    if (
      !loading &&
      data &&
      data?.UserAccounts &&
      data.UserAccounts.length > 0
    ) {
      setOptions(data.UserAccounts);
    }
  }, [data, loading]);

  React.useEffect(() => {
    if (InputPropsValue) {
      const findObject = options.find((item) => item.id === InputPropsValue);
      if (findObject) {
        setValue(findObject);
      } else {
        setValue(null);
      }
    } else {
      setValue(null);
    }
  }, [options, InputPropsValue]);

  const onChange = function (inputVal: any) {
    onValueChanged(inputVal);
    setValue(inputVal);
  };

  return (
    <Stack id="UsersAutoComplete">
      {options && options.length > 0 && (
        <CustomAutoComplete
          id="tags-UsersAutoComplete"
          sx={{ width: width ? width : 300 }}
          value={value}
          disabled={!edit}
          clearIcon={false}
          filterSelectedOptions
          onChange={(event, newValue) => {
            onChange(newValue);
          }}
          //@ts-ignore
          isOptionEqualToValue={(option, val) => option.id === val.id}
          //@ts-ignore
          getOptionLabel={(option) => option.name}
          // @ts-ignore
          renderOption={(propsVal: any, option: any) => (
            <li {...propsVal} key={option.id}>
              {option.name}
            </li>
          )}
          options={options}
          loading={loading}
          defaultValue={[]}
          renderInput={(params) => (
            <CustomTextField
              controldisabled={!edit}
              {...params}
              label={label ? label : t("labels.user")}
              placeholder={t("labels.user")}
            />
          )}
        />
      )}
    </Stack>
  );
};

export default UsersAutoComplete;
